import { render, staticRenderFns } from "./DisabilityTrust.vue?vue&type=template&id=3a7d5b5e"
import script from "./DisabilityTrust.vue?vue&type=script&lang=js"
export * from "./DisabilityTrust.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports